import { ACTIVE_TAB_OBJ, FILTER_ACTION } from '@features/notification/utils/Utils';

import { Types } from '@store/types';

const initialState = {
	notifications: [],
	notificationIconActive: true,
	sort: 'id,desc',
	dataLoadedOnce: false,
	page: 0,
	size: 10,
	hasNext: true,
	unseenCount: 0,
	unseenCountObj: {},
	notificationTabName: ACTIVE_TAB_OBJ.mentions.value,
	notificationFilterName: FILTER_ACTION.all,
	replyCommentList: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_NOTIFICATION_DATA: {
			return {
				...state,
				[action.payload.key]: action.payload.data
			};
		}
		case Types.SET_NOTIFICATION_REPLY_COMMENT: {
			let tempNotification = state.notifications.map((obj) => {
				if (obj.id === action.payload.id) {
					obj.reply = action.payload.body;
					obj.replyActorName = action.payload.actorName;
				}
				return obj;
			});
			return {
				...state,
				notifications: tempNotification
			};
		}
		default:
			return state;
	}
};
